export default "//static.tradera.net/touchweb/static/output/images/app-store-badge-sv.19fb3831.svg";